import { render, staticRenderFns } from "./wrapBox.vue?vue&type=template&id=0b34292e&scoped=true"
import script from "./wrapBox.vue?vue&type=script&lang=js"
export * from "./wrapBox.vue?vue&type=script&lang=js"
import style0 from "./wrapBox.vue?vue&type=style&index=0&id=0b34292e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b34292e",
  null
  
)

export default component.exports